export default "__VITE_ASSET__D7wz2p6Z__"